(() => {
  if (customElements.get('complementary-products')) {
    return;
  }

  class ComplementaryProducts extends customElements.get('card-product-slider') {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.hasAttribute('data-url')) {
        this.fetchItems();
      }
    }

    fetchItems() {
      const sectionId = this.dataset.sectionId;
      const track = this.querySelector('.styled-slider__track');
      if (!track) return;

      fetch(this.getAttribute('data-url'))
        .then(response => response.text())
        .then(text => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const fetchedTrack = html.querySelector('.styled-slider__track');
          if (fetchedTrack && fetchedTrack.innerHTML.trim().length) {
            track.innerHTML = fetchedTrack.innerHTML;
            this.parentElement.classList.remove('hidden');
            const sectionRoot = this.parentElement?.closest('[data-section-id]');
            if (sectionRoot) sectionRoot.classList.remove('hidden');
            document.dispatchEvent(
              new CustomEvent('slider:updated', { detail: { for: sectionId } })
            );
            if (document.querySelector('quick-cart-drawer')) {
              document.querySelector('quick-cart-drawer').init();
            }
          }
        })
        .catch(e => console.error(e));
    }
  }

  customElements.define('complementary-products', ComplementaryProducts);
})();
